// src/features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit"

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    role: null,
    isAuthenticated: false
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token
      state.role = action.payload.role
      state.isAuthenticated = true
      localStorage.setItem("token", action.payload.token)
      localStorage.setItem("role", action.payload.role)
    },
    logoutUser: (state) => {
      state.token = null
      state.role = null
      state.isAuthenticated = false
      localStorage.clear()
    }
  }
})

export const { loginSuccess, logoutUser } = authSlice.actions
export default authSlice.reducer
